import { lazy, Suspense } from 'react';

import { ClientSideComponent } from '@crehana/web';
import cls from 'classnames';

import usePhoneNumberState from './hooks/usePhoneNumberState';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { PhoneState as _PhoneState, TPhoneInputProps } from './types';

const LazyComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "shared-react-phone-input" */
      './PhoneInput'
    ),
);

const LazyPhoneInput: React.FC<
  React.PropsWithChildren<TPhoneInputProps>
> = props => {
  const loader = (
    <>
      {props.label ? (
        <div
          className={cls('w-1/3 h-20 mb-8 rounded-5', {
            'bg-neutral-dark-700': props.isDark || props.isDarkMode,
          })}
        />
      ) : null}
      <div
        className={cls('w-full h-56 mb-24 rounded-5', {
          'bg-neutral-dark-700': props.isDark || props.isDarkMode,
        })}
      />
    </>
  );

  return (
    <ClientSideComponent fallback={loader}>
      <Suspense fallback={loader}>
        <LazyComponent {...props} />
      </Suspense>
    </ClientSideComponent>
  );
};

export { usePhoneNumberState };

export type PhoneState = _PhoneState;

export type { TPhoneInputProps };
export { LazyPhoneInput as PhoneInput };

export default LazyPhoneInput;
